import colors from 'shared/colors';

export const FALLBACK_RELEASE_CATEGORY_COLOR = 'grey';

// Source of truth: mooncamp-website sanity/schemas/releaseCategories.ts; keep the two in sync.
export const releaseCategories = [
  { id: 'goals', label: 'Goals', color: 'blue' },
  { id: 'checkins', label: 'Check-ins', color: 'green' },
  { id: 'dashboards', label: 'Dashboards', color: 'purple' },
  { id: 'plans', label: 'Plans', color: 'orange' },
  { id: 'views', label: 'Views', color: 'orange' },
  { id: 'notifications', label: 'Notifications', color: 'grey' },
  { id: 'integrations', label: 'Integrations', color: 'yellow' },
  { id: 'slack', label: 'Slack', color: 'yellow' },
  { id: 'msteams', label: 'Microsoft Teams', color: 'yellow' },
  { id: 'workspaces', label: 'Workspaces', color: 'pink' },
  { id: 'members', label: 'Members & access', color: 'red' },
  { id: 'security', label: 'Security & SSO', color: 'red' },
  { id: 'settings', label: 'Settings', color: 'grey' },
  { id: 'performance', label: 'Performance', color: 'grey' },
];

const byId = new Map(releaseCategories.map((category) => [category.id, category]));

export const releaseCategoryLabel = (id) => byId.get(id)?.label ?? id ?? '';

export const releaseCategoryColor = (id) => byId.get(id)?.color ?? FALLBACK_RELEASE_CATEGORY_COLOR;

export const releaseCategoryDotColor = (id) => colors[releaseCategoryColor(id)].base;
